import React from 'react';

//Componentes
import TableContainer from '../../components/table/TableContainer';

//Estilos
import './GuiasList.css';

function GuiasList({ functions, states }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        newGuia,
    } = functions;

    const { GuiasListData, tableData, viniedos, settings, EnableBtn } = states;

    return (
        <div className="guias_list-container">
            {tableData.data.length > 0 ? (
                <>
                    <TableContainer tableData={tableData} />
                </>
            ) : (
                <h3>No tiene ninguna guía disponible</h3>
            )}
            {new Date(settings?.djcp_rango_inicio) <
                new Date() <
                new Date(settings?.djcp_rango_fin) && (
                <div className="guias_list-footer">
                    <form onSubmit={handleSubmit(newGuia)}>
                        <select {...register('myViniedo')}>
                            <option value={0}>Elegir Viñedo</option>
                            {viniedos?.map((v) => {
                                return (
                                    <option key={v.id} value={v.id}>
                                        {v.num}
                                    </option>
                                );
                            })}
                        </select>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={EnableBtn === 0}
                        >
                            Nueva Guía
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
}

export default GuiasList;
